import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'assets/custom-theme/index.css'; // 换肤版本element-ui css
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条 样式
import 'normalize.css/normalize.css';// normalize.css 样式格式化
import 'assets/iconfont/iconfont'; // iconfont 具体图标见https://github.com/PanJiaChen/vue-element-admin/wiki
import * as filters from './filters'; // 全局vue filter
import IconSvg from 'components/Icon-svg';// svg 组件
import errLog from 'store/errLog';// error log组件
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAreaLinkage from 'vue-area-linkage';

// import './mock/index.js';  // 该项目所有请求使用mockjs模拟
Vue.component('icon-svg', IconSvg)
Vue.use(ElementUI);
Vue.use(VueAreaLinkage);

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
});

function hasPermission(roles, route) {
    if (route.meta && typeof route.meta === 'string') {
        if (roles.indexOf(route.meta) < 0) {
            return false
        }
    }
    return true
}

// register global progress.
const whiteList = ['/authredirect', '/reset', '/sendpwd', '/404', '/401'];// 不重定向白名单
router.beforeEach((to, from, next) => {
    console.log('beforeEach', from.path, to.path)
    NProgress.start(); // 开启Progress
    // next(); return
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next();
        return;
    }
    let addRouterl = JSON.parse(localStorage.getItem("addRouters"))
    if (!store.getters.userName) {
        store.dispatch('GetInfo').then(res => { // 拉取user_info
            let roleList = res.roleList
            store.dispatch('setRouter', roleList).then(() => { // 生成可访问的路由表
                let addRouters = store.getters.addRouters
                localStorage.setItem('addRouters', JSON.stringify(addRouters));
                router.addRoutes(addRouters) // 动态添加可访问路由表
                if (to.path == '/login') {
                    next('/admin/index')
                } else {
                    next();
                }
            })

        }).catch(error => {
            if(error.status === 401) {
                next('/login');
            }
            next();
        })
    }
    next();
    return;
});

router.afterEach(() => {
    NProgress.done(); // 结束Progress
});

Vue.config.productionTip = false;

// 生产环境错误日志
if (process.env === 'production') {
    Vue.config.errorHandler = function (err, vm) {
        console.log(err, window.location.href);
        errLog.pushLog({
            err,
            url: window.location.href,
            vm
        })
    };
}
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js